import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import moment from 'moment';
import { partial } from '../../../../util/translation/translation';

// Saving a series: which future occurrences get the changes. Occurrences
// changed by hand, cancelled or already started are never touched.
const ApplyChangesModal = ({ isOpen, occurrences, onClose, onApply, busy }) => {
  const p = partial('EventSeries');
  const [applyTo, setApplyTo] = useState('all');

  useEffect(() => {
    if (isOpen) setApplyTo('all');
  }, [isOpen]);

  const now = moment();
  const future = occurrences.filter(
    (occurrence) =>
      moment(occurrence.startDate).isAfter(now) && !occurrence.cancelledAt
  );
  const changeable = future.filter((occurrence) => !occurrence.changedByHand);
  const withoutBookings = changeable.filter(
    (occurrence) => !occurrence.participantCount
  );
  const changedByHand = future.length - changeable.length;

  const choices = [
    {
      value: 'all',
      label: p('applyAll', { count: changeable.length }),
      hint: p('applyAllHint'),
    },
    {
      value: 'withoutBookings',
      label: p('applyWithoutBookings', { count: withoutBookings.length }),
      hint: p('applyWithoutBookingsHint'),
    },
  ];

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{p('applyTitle')}</ModalHeader>
      <ModalBody>
        {choices.map((choice) => (
          <Label check className="series-apply__choice" key={choice.value}>
            <Input
              type="radio"
              name="seriesApplyTo"
              checked={applyTo === choice.value}
              onChange={() => setApplyTo(choice.value)}
            />
            <span>
              <strong className="d-block">{choice.label}</strong>
              <small className="text-muted">{choice.hint}</small>
            </span>
          </Label>
        ))}
        <p className="text-muted mb-0 mt-2" style={{ fontSize: 12 }}>
          {changedByHand > 0
            ? p('applyChangedByHand', { count: changedByHand })
            : p('applyPastNever')}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={onClose}>
          {p('cancel')}
        </Button>
        <Button
          color="primary"
          className="mb-0"
          disabled={busy}
          onClick={() => onApply(applyTo)}
        >
          {p('apply')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ApplyChangesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  occurrences: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  busy: PropTypes.bool,
};

ApplyChangesModal.defaultProps = {
  occurrences: [],
  busy: false,
};

export default ApplyChangesModal;
